// ✅ src/pages/ParcaTahmin.js (Final)
import React, { useState, useEffect } from 'react';
import { Bar } from 'react-chartjs-2';
import 'chart.js/auto';
import '../pages/ParcaTahmin.css';

const dummyData = [
  { parca: 'Yağ Filtresi', aylikKullanim: [5, 8, 6, 10, 7, 9] },
  { parca: 'Hava Filtresi', aylikKullanim: [3, 5, 4, 6, 7, 5] },
  { parca: 'Seperatör', aylikKullanim: [2, 3, 4, 4, 5, 3] }
];

const ParcaTahmin = () => {
  const [selectedParca, setSelectedParca] = useState(dummyData[0]);
  const [chartData, setChartData] = useState({});

  useEffect(() => {
    if (!selectedParca || !selectedParca.aylikKullanim) return;

    setChartData({
      labels: ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran'],
      datasets: [
        {
          label: `${selectedParca.parca} Aylık Kullanım`,
          data: selectedParca.aylikKullanim,
          backgroundColor: 'rgba(54, 162, 235, 0.6)',
          borderRadius: 6,
        },
      ],
    });
  }, [selectedParca]);

  return (
    <div className="parca-tahmin-container">
      <h2>📊 Parça Tahmin & Öneri</h2>
      <select
        className="dropdown"
        onChange={(e) => {
          const found = dummyData.find(p => p.parca === e.target.value);
          setSelectedParca(found || dummyData[0]);
        }}
      >
        {dummyData.map((p, index) => (
          <option key={index} value={p.parca}>
            {p.parca}
          </option>
        ))}
      </select>

      <div className="chart-wrapper">
        {chartData?.datasets?.length > 0 ? <Bar data={chartData} /> : <p>📉 Veri bulunamadı.</p>}
      </div>
    </div>
  );
};

export default ParcaTahmin;